import { env } from '@/config/env';

export const fetchDesktopWithTimeout = async (
  path: RequestInfo | URL,
  init?: RequestInit,
  ms = 1200
) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), ms);
  try {
    const res = await fetch(
      `${env.VITE_HITPHONE_DESKTOP_URL}` + String(path),
      {
        ...(init ?? {}),
        signal: controller.signal,
      }
    );
    return res;
  } finally {
    clearTimeout(id);
  }
};
